import { render, staticRenderFns } from "./sameIpDialog.vue?vue&type=template&id=22f07f38&scoped=true"
import script from "./sameIpDialog.vue?vue&type=script&lang=js"
export * from "./sameIpDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f07f38",
  null
  
)

export default component.exports